import client from '@/clients/customer/api-client';
import Qs from 'qs';
import { withCacheTTL } from '../common/with-cache-ttl';
import { env } from '@/constant/configs';

export const restaurantTags = (filter: any | null = null, headers = {}) =>
  client.get('/restaurant-tags', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });

// Wrap the fetching function with caching and a TTL of 1 minute
export const cachedRestaurantTags = withCacheTTL(
  restaurantTags,
  '/restaurant-tags'
);

export const restaurantTagsPath = env.api_url + '/v1/customer/restaurant-tags';
